const duplicateTranslationKey = (key: string): string => key;

export const translationStatistics_en_part1 = {
  tokenMissing: "Token or chatbotID not found",
  choosePeriod: "Period",
  topicFilterLabel: "Topic",
  topicFilterAllPlaceholder: "All topics",
  topicFilterOtherOption: "Other",
  topicFilterArchivedLabel: "archived",
  topicFilterClear: "Clear topic filter",
  topicFilterSelectedCount: "{count} topics",
  topicGroupSave: "Save as group",
  topicGroupSaveConfirm: "Save",
  topicGroupName: "Group name",
  topicGroupNamePlaceholder: "E.g. Customer service",
  topicGroupDelete: "Delete group",
  topicFilterReportNotice:
    "The page's topic filter is not applied to reports – the report covers all topics.",
  allTimes: "All Times",
  last7Days: "Last 7 Days",
  last30Days: "Last 30 Days",
  last3Months: "Last 3 Months",
  yesterday: "Yesterday",
  today: "Today",
  customRange: "Custom",
  statisticsTabPerformance: "AI performance",
  statisticsTabTopics: "Topics & conversations",
  statisticsTabListLabel: "Statistics sections",
  overviewSectionTitle: "Overview",
  resolutionSectionTitle: "Resolution",
  aiEffectivenessSectionTitle: "AI effectiveness",
  commerceSectionTitle: "Business impact",
  comparePreviousPeriod: "Compare to previous period",
  vsPreviousPeriod: "vs previous period",
  comparePreviousPeriodTooltip:
    "Shows how each KPI changed compared with the immediately preceding period of equal length.",
  comparePreviousPeriodUnavailableTooltip:
    "Comparison is not available for All time because there is no valid preceding period.",
  comparePreviousPeriodInfo: "Compare to previous period info",
  lastUpdated: "Last updated",
  refresh: "Refresh",
  actions: "Actions",
  allChatbots: "All chatbots",
  conversationsBySource: "Conversations by source",
  conversationsBySourceDescription:
    "Which entry point each conversation started from — the floating widget, popup, inline search or API. Shares add up to all conversations in the period.",
  conversationsBySourceTotal: "{total} conversations in the selected period",
  noSourceData: "No source breakdown available for this period.",
  statisticsLoadError: "Could not load statistics",
  statisticsLoadErrorDescription: "Try refreshing the page.",
  outcomeBreakdownTitle: "Resolution outcomes",
  outcomeBreakdownPartitionHint:
    "Each segment is a share of classified conversations (those with a resolution category) and adds up to 100%. Unclassified conversations are excluded.",
  resolutionTotalLabel: "Classified conversations",
  resolutionCoverageLabel: "Classified conversations: {classified} of {total} ({percent}%)",
  activitySectionTitle: "Activity",
  hourLabel: "Hour",
  messagesLabel: "Messages",
  performanceSectionDescription:
    "AI effectiveness, escalations, and engagement for the selected period.",
  satisfactionChartsTitle: "Satisfaction",
  statisticsSettingsDescription: "Configure business hours, visible metrics, and topic management.",
  notificationsSheetDescription: "Get alerted when topic volume increases beyond a threshold.",
  viewTopicDetails: "View topic details",
  livechatVolumeTitle: "Livechat volume",
  livechatSatisfactionTitle: "Livechat satisfaction",
  livechatTopicsTitle: "Livechat topics",

  insights: "Insights",
  totalMessages: "Total Messages",
  avgMessagesPerDay: "Average Messages per Day",
  totalConversations: "Total Conversations",
  totalUserRatings: "Total User Ratings",
  averageRating: "Average User Rating",
  thumbsUpPercentage: "Thumbs Up Percentage",
  csatScore: "Customer Satisfaction (CSAT)",
  chatbotSatisfaction: "Chatbot Satisfaction",

  dailyMessages: "Daily Messages",
  weeklyMessages: "Weekly Messages",
  weekOf: "Week of",
  ongoingDay: "Ongoing day",
  weekInProgress: "ongoing week",
  loadingDailyData: "Loading daily data...",
  topicMessages: "Conversations by Topic",
  loadingTopicData: "Loading topic data...",
  timeOfDay: "Time of Day",
  loadingHourlyData: "Loading hourly data...",
  ratingDistribution: "Rating distribution (1-5)",
  ratingDistributionTooltip:
    "Number of conversations with a user rating at each level (integer ratings 1-5 only).",
  ratingDistributionEmpty: "No ratings yet for this period",
  csatOverTime: "CSAT over time",
  csatOverTimeTooltip:
    "Average customer satisfaction (CSAT) score per period in the selected date range.",
  csatOverTimeEmpty: "No ratings yet for this period",
  csatOverTimeYAxis: "CSAT (%)",
  csatRegressionLine: "Trend line",
  csatRegressionSlopeDay: "{{slope}} pp / day",
  csatRegressionSlopeWeek: "{{slope}} pp / week",
  csatRegressionSlopeMonth: "{{slope}} pp / month",
  resolutionOverTime: "Resolution rate over time",
  resolutionOverTimeEmpty: "No classified conversations yet for this period",
  resolutionOverTimeYAxis: "Resolution (%)",
  csatOverTimeChartSetting: "CSAT over time chart",
  csatOverTimeChartSettingTooltip:
    "Show a line chart of how CSAT score trends over the selected date range.",

  dateLabel: "Date",
  messageCount: "Message Count",
  topicLabel: "Topic",
  conversationCount: "Conversations",
  openCount: "Opens",
  timeLabel: "Time",
  showAll: "Show all",
  showLess: "Show less",
  other: "Other",
  percentage: "Percentage",

  // Weekend hours translations

  // Weekend hours translations

  outsideBusinessHours: "Outside business hours",
  outsideBusinessHoursTooltip: "Percentage of messages sent outside business hours",
  outsideBusinessHoursTooltipDescription: "Percentage of messages sent outside business hours",

  // TTFT (Time to First Token) translations

  // TTFT (Time to First Token) translations
  averageTtft: "Avg Time to First Token",
  averageTtftTooltip: "Average time from message received to first token sent",
  p50Ttft: "P50 Time to First Token",
  p50TtftTooltip: "Median (50th percentile) time from message received to first token sent",
  p95Ttft: "P95 Time to First Token",
  p95TtftTooltip: "95th percentile time from message received to first token sent",
  p99Ttft: "P99 Time to First Token",
  p99TtftTooltip: "99th percentile time from message received to first token sent",
  responseLatencyMetrics: "Response latency (TTFT, P50, P95)",
  responseLatencyMetricsTooltip:
    "Show time to first token plus P50 and P95 latency splits on the statistics page",
  p99LatencyMetric: "Response latency (P99)",
  p99LatencyMetricTooltip: "Show the P99 time to first token on the statistics page",
  ttftBreakdownLabel: "Time to First Token Breakdown",
  totalTtft: "Total TTFT",
  detailedBreakdown: "Detailed Breakdown (in order)",
  noTtftData: "No TTFT data available",

  [duplicateTranslationKey("outsideBusinessHoursTooltipDescription")]:
    "Percentage of messages sent outside business hours",
  startTime: "Start time",
  endTime: "End time",
  weekendHours: "Weekend hours",
  saturdayHours: "Saturday",
  sundayHours: "Sunday",
  weekendHoursTooltip: "Percentage of messages sent during weekend hours",
  weekendHoursTooltipDescription: "Percentage of messages sent during weekend hours",
  [duplicateTranslationKey("weekendHoursTooltipDescription")]:
    "Percentage of messages sent during weekend hours",
  supportHours: "Support opening hours",
  settingsSaved: "Settings saved",
  settingsSaveError: "Error saving settings",
  businessHoursInvalidRange: "End time must be later than start time. The hours were not saved.",
  weekendSupport: "Support in the weekend",

  // New translations for report generation,
};
